import Table from "components/Table/Table";
import { format, parseISO } from "date-fns";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { DATE_AND_TIME_FORMAT } from "utils/date-utils";
import { useConstants } from "utils/hooks";

type ConsultingDocumentType = {
  id: number;
  original_filename: string;
  type: string;
  created: string;
  ocr_status: string;
};

const ConsultingDocumentsList = ({
  documents,
}: {
  documents: ConsultingDocumentType[];
}) => {
  const navigate = useNavigate();
  const { constants } = useConstants();

  // function to convert document type to human-readable label
  const getDocumentTypeLabel = (type: string) => {
    return (
      constants?.DOCUMENT_TYPES?.find(
        (t: { value: string; label: string }) => t.value === type,
      )?.label || type
    );
  };

  const columns = useMemo(() => {
    return [
      {
        key: "original_filename",
        name: "Document Name",
        width: "40%",
        resizeable: true,
      },
      {
        key: "type",
        name: "File Type",
        width: "30%",
        resizeable: true,
        renderCell: ({ row }: { row: ConsultingDocumentType }) => (
          <div>{getDocumentTypeLabel(row.type)}</div>
        ),
      },
      {
        key: "created",
        name: "Date",
        width: "20%",
        resizeable: true,
        renderCell: (props) => {
          return format(parseISO(props.row.created), DATE_AND_TIME_FORMAT);
        },
      },
      // {
      //   key: "ocr_status",
      //   name: "OCR Status",
      //   width: "10%",
      //   renderCell: () => (
      //     <div className="flex jc-se">
      //       <span className="ocr-status green material-icons">
      //         check_circle
      //       </span>
      //     </div>
      //   ),
      //   resizeable: true,
      // },
      {
        key: "actions",
        name: "Actions",
        width: "5%",
        renderCell: (props) => (
          <div className="action-cell">
            <div
              className="material-icons edit"
              title="Archive"
              onClick={() => {
                navigate(
                  `/previews?key=${props.row.s3_key}&url=${props.row.proxy_url}`,
                );
              }}
            >
              preview
            </div>
          </div>
        ),
      },
    ];
  }, [constants]);

  return (
    <div className={`card form audit-and-consulting-card`}>
      <div className="card__header">Uploaded Documents</div>
      <Table
        className="table documents-table document-audit-table"
        columns={columns as never}
        rows={documents}
        rowKeyGetter={(row) => row.id}
      />
    </div>
  );
};

export default ConsultingDocumentsList;
